/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import React, { useState, useEffect } from "react";
import {
  I2cButton,
  I2cIcon,
  I2cInput,
  I2cPagination,
  I2cDropdown,
  I2cMenu,
  I2cMenuItem,
  I2cDrawer,
  I2cActivityFeeds,
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../../Utils/shared-styles/Authentication.scss";
import "./SalesRequest.scss";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useQuery } from "react-query";
import AlertMessage from "../../Components/SharedComponent/Alert/Alert";
import { OverlayLoader } from "../../Components/Loader/Loader";
import "pure-react-carousel/dist/react-carousel.es.css";
import SingleSalePreview from "./SingleSalePreview";
import { GuideCard } from "../../Components/GuideCard/GuideCard";
import { FiltersDrawerContent } from "./FiltersDrawerContent";
import SalesService from "../../Services/SalesService";
import UserManagmentService from "../../Services/UsermanagmentService";
import { useLocation } from "react-router-dom";
import { UserStateContext } from "../../Context/AuthContext";
import _ from "lodash";

/**
 * Component for displaying and managing sales requests.
 */
const SalesRequests = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isUserAdded = searchParams.get("user-added") ?? false;

  const [page, setPage] = useState(1);
  const zIndexForGuide = 99999;
  const [guideStep, setGuideStep] = useState(20);
  const [openSupport, setSupportOpen] = useState(false);
  const [filterData, setFilterData] = useState({
    status: "",
    type: "",
    from: "",
    to: "",
  });
  const appContext = UserStateContext();
  const [searchKey, setSearchkey] = useState("");
  const [debouncedSearchKey, setDebouncedSearchKey] = React.useState("");
  const toggleDrawer = () => {
    setSupportOpen(!openSupport);
  };

  const {
    data: user,
    refetch: refetchUserProfile,
    remove,
  } = useQuery("userProfile", () => UserManagmentService.getUserProfile(), {
    staleTime: 300000,
  });
  
  const profileData = user?.data?.data?.user;
  const userRole = String(appContext.userRole || profileData?.role_id || "");
  const roleName = String(
    appContext.roleName || profileData?.role_name || profileData?.roleName || "",
  ).toLowerCase();
  const clientUser = userRole === "5" || roleName === "client";
  const isRoleId = ["5", "6", "7"].includes(userRole);

  useEffect(() => {
    if (clientUser && window.location.pathname.includes("/sales")) {
      navigate("/impl", {
        replace: true,
      });
    }
  }, [clientUser, navigate]);

  // Debounce the value change
  React.useEffect(() => {
    const debounceSearch = _.debounce((value) => {
      setDebouncedSearchKey(value);
      // setDebouncedLoading(false);
    }, 1000); // Adjust the debounce delay as needed (e.g., 300ms)

    debounceSearch(searchKey);

    return () => {
      debounceSearch.cancel(); // Cancel the debounce function on component unmount
    };
  }, [searchKey]);

  const location = useLocation();
  const route = location.pathname.includes("sales") ? 0 : 1;

  const fetchSales = async (route) => {
    const res = await SalesService.getSales(
      page,
      clientUser ? 1 : route,
      filterData,
      debouncedSearchKey,
    );
    return res.data.data;
  };

  // Fetch sales data using React Query hook
  const queryKey = ["sales-requests", page, filterData, debouncedSearchKey];
  const {
    data: sales = [],
    isLoading,
    refetch,
    isFetching,
  } = useQuery(queryKey, () => fetchSales(route), {
    refetchOnWindowFocus: false,
  });
  useEffect(() => {
    setPage(1);
    // This function will be called whenever the route changes
    refetch();
  }, [route]);
  useEffect(() => {
    const storedGuideStep = localStorage.getItem("guideStep");
    const isClient = roleName === "client";
    const isStakeholder = roleName === "stakeholder" || userRole === "7";
    if (storedGuideStep !== "true" && !isClient && !isStakeholder) {
      const delayTimeout = setTimeout(() => {
        setGuideStep(1);
        localStorage.setItem("guideStep", "true");
      }, 5000);
      return () => clearTimeout(delayTimeout);
    }
  }, [roleName, userRole]);

  const guideDescription = [
    {
      activeStep: 1,
      headerText: "Add New Project",
      description: "Add an item to start managing and tracking CSDs.",
      onClickNext: () => setGuideStep(guideStep + 1),
      onClickClose: () => setGuideStep(20),
    },
    {
      activeStep: 2,
      headerText: "Filter(s)",
      description:
        "Search for required record by clicking and adding data for results.",
      footer: "",
      onClickPrev: () => setGuideStep(guideStep - 1),
      onClickNext: () => setGuideStep(guideStep + 1),
      onClickClose: () => setGuideStep(20),
    },

    {
      activeStep: 3,

      headerText: "Quick Search Records",
      description:
        "Enables users to swiftly locate specific records or data points within a database or system.",
      footer: "",
      onClickPrev: () => setGuideStep(guideStep - 1),
      onClickNext: () => setGuideStep(20),
      onClickClose: () => setGuideStep(20),
    },
  ];
  function handleSupportRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    } else {
      setSupportOpen(false);
    }
  }
  return (
    <div className="salesRelative">
      {!(guideStep === 20) && <div className="overlay-guide-steps"></div>}
      <I2cDrawer
        label="Filters"
        className="sales-filter-drawer"
        sub-label=""
        open={openSupport}
        onI2cRequestClose={handleSupportRequestClose}
        ref={I2cDrawer}
      >
        <I2cActivityFeeds variant="" type="notification">
          <FiltersDrawerContent
            onClose={() => {
              setFilterData(null);
              setSupportOpen(false);
            }}
            filterData={filterData}
            setilterData={setFilterData}
            handleConfirmation={(filterData) => {
              setSupportOpen(false);
              setFilterData(filterData);
            }}
          />
        </I2cActivityFeeds>
      </I2cDrawer>
      <div className="layout_aside_logged_user1 sales-requests-listing">
        <div i2c-grid="grid" className="sales-requests-listing-header">
          <div i2c-grid="5@lg 12@md" className="sales-requests-listing-title">
            <h2>Client Request</h2>
          </div>
          <div
            i2c-grid="7@lg 12@md"
            className="sales-requests-listing-header-actions"
          >
            <div
              style={{ zIndex: guideStep === 2 ? zIndexForGuide : "inherit" }}
              className="filter-action"
            >
              <I2cButton onClick={toggleDrawer} variant="secondary gray">
                <I2cIcon name="linear-setting-4" />
              </I2cButton>
              {guideStep === 2 && (
                <GuideCard
                  guidStepObject={guideDescription[guideStep - 1]}
                  totalCount={guideDescription.length}
                />
              )}
            </div>

            {!isRoleId && (
              <div
                style={{ zIndex: guideStep === 1 ? zIndexForGuide : "inherit" }}
                className="add-new-action"
              >
                <I2cDropdown
                  className="add-new-action-btn"
                  distance="0"
                  width="calc(var(--i2c-spacing-40) + var(--i2c-spacing-0.5))"
                >
                  <I2cButton
                    className="add-new-action-btn"
                    slot="trigger"
                    // caret
                  >
                    <I2cIcon slot="suffix" name="cs-linear-chevron-down" />
                    Add Project
                  </I2cButton>
                  <I2cMenu className="add-new-project-menu">
                    <I2cMenuItem
                      size="small"
                      onClick={() => navigate("/debit/add")}
                      className="add-project-menu-item"
                    >
                      <span>Prepaid/Debit</span>
                      <I2cIcon slot="prefix" name="linear-bitcoin-convert" />
                    </I2cMenuItem>
                    <I2cMenuItem
                      size="small"
                      onClick={() => navigate("/credit/add")}
                      className="add-project-menu-item"
                    >
                      <span>Credit</span>
                      <I2cIcon slot="prefix" name="linear-card-pos" />
                    </I2cMenuItem>
                    {/* <I2cMenuItem
                      size="small"
                      // onClick={() => navigate('/debit/add')}
                      className="add-project-menu-item"
                    >
                      <span>Core Banking</span>
                      <I2cIcon slot="prefix" name="linear-bank" />
                    </I2cMenuItem> */}
                  </I2cMenu>
                </I2cDropdown>
                {guideStep === 1 && (
                  <GuideCard
                    guidStepObject={guideDescription[guideStep - 1]}
                    totalCount={guideDescription.length}
                  />
                )}
              </div>
            )}

            <div
              style={{ zIndex: guideStep === 3 ? zIndexForGuide : "inherit" }}
              className="search-bar-action"
            >
              <I2cInput
                name="search"
                style={{
                  width: "calc(var(--i2c-spacing-64) - var(--i2c-spacing-1-5))",
                }}
                onI2cInput={(e) => setSearchkey(e.target.value)}
                placeholder="Search"
                size="medium"
              >
                <I2cIcon slot="prefix" name="cs-linear-search" />
              </I2cInput>
              {guideStep === 3 && (
                <GuideCard
                  guidStepObject={guideDescription[guideStep - 1]}
                  totalCount={guideDescription.length}
                />
              )}
            </div>
          </div>
          <div
            style={{ zIndex: guideStep === 3 ? zIndexForGuide : "inherit" }}
            className="search-bar-action-mobile"
          >
            <I2cInput name="search" placeholder="Search" size="medium">
              <I2cIcon slot="prefix" name="cs-linear-search" />
            </I2cInput>
            {guideStep === 3 && (
              <GuideCard
                guidStepObject={guideDescription[guideStep - 1]}
                totalCount={guideDescription.length}
              />
            )}
          </div>
        </div>
        {isUserAdded && (
          <div className="user-added-success-message">
            <AlertMessage
              variant="success"
              message={"User has been added successfully"}
              headerArt="linear-tick-circle"
              open={isUserAdded}
              closeAble={true}
            />
          </div>
        )}
        <div i2c-grid="grid 12@sm" className="sales-requests-listing-section">
          {sales?.data?.length
            ? sales.data.map((sale, index) => (
                <div
                  key={index}
                  i2c-grid="grid 12@sm"
                  className="sales-requests-listing-section-single-sale"
                >
                  <SingleSalePreview
                    key={index}
                    sale={sale}
                    queryKey={queryKey}
                    onDeleteSuccess={() => setPage(1)}
                  />
                </div>
              ))
            : !isLoading && (
                <div i2c-grid="12@sm" className="no-request-container">
                  <I2cIcon
                    className="cs-icon-shadowed"
                    variant="shadowed"
                    name="linear-info-circle"
                  />
                  <div className="no-request-title">No Client(s) Request</div>
                  <div className="no-request-text">
                    It seems like there are currently no clients matching your
                    search criteria or available in the system.
                  </div>
                </div>
              )}
        </div>
        {sales?.data?.length ? (
          <div>
            <I2cPagination
              className="sales-list-pagination"
              quickButtonsAsLink
              totalCount={sales?.total}
              pageSize={sales?.per_page ?? 4}
              currentPage={page}
              setPage={setPage}
            ></I2cPagination>
          </div>
        ) : null}
      </div>
      {(isLoading || isFetching) && <OverlayLoader />}
    </div>
  );
};

export default SalesRequests;
